import { slick } from "@accessible360/accessible-slick";

class RelatedContent {
    constructor(element) {
        // Class properties.
        this.relContentBlock = element;

        this.slickCarousel = {};

        // Carousel arrows.
        this.backArrow = `<svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg"><mask id="mask0_8284_28986" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="40" height="40"><rect width="40" height="40" fill="#D9D9D9"/></mask><g mask="url(#mask0_8284_28986)"><path d="M13.75 21.5L22.125 29.875L20 32L8 20L20 8L22.125 10.125L13.75 18.5H32V21.5H13.75Z" fill="black"/></g></svg>`;

        this.nextArrow = `<svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg"><mask id="mask0_8284_28992" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="40" height="40"><rect width="40" height="40" fill="#D9D9D9"/></mask><g mask="url(#mask0_8284_28992)"><path d="M26.25 21.5H8V18.5H26.25L17.875 10.125L20 8L32 20L20 32L17.875 29.875L26.25 21.5Z" fill="black"/></g></svg>`;

        this.init();
    }

    init() {
        this.createCarousel();
    }

    createCarousel() {
        let props = {
            slidesToShow: 3,
            slidesToScroll: 1,
            autoplay: false,
            arrows: true,
            infinite: false,
            speed: 300,
            adaptiveHeight: true,
            arrowsPlacement: "beforeSlides",
            prevArrow:
                '<button type="button" data-control-prev><span class="sr-text">Previous</span>' +
                this.backArrow +
                "</button>",
            nextArrow:
                '<button type="button" data-control-next><span class="sr-text">Next</span>' +
                this.nextArrow +
                "</button>",
            responsive: [
                {
                    breakpoint: 767,
                    settings: {
                        slidesToShow: 1
                    }
                }
            ]
        };

        // Init slick carousel.
        let carousel = $(this.relContentBlock).slick(props);

        this.slickCarousel = carousel;
    }
}

document.addEventListener("DOMContentLoaded", () => {
    const relContentCarousels = document.querySelectorAll(
        '[data-carousel="related-content"]',
    );

    relContentCarousels.forEach((element) => {
        new RelatedContent(element);
    });
});

export default RelatedContent;
